import { render } from "./DetectConvertorForm.vue?vue&type=template&id=062af754"
import script from "./DetectConvertorForm.vue?vue&type=script&lang=js"
export * from "./DetectConvertorForm.vue?vue&type=script&lang=js"
script.render = render

export default script